export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    console.warn("[AUTH] No token found. Redirecting to login.");
    throw new Error("Missing token");
  }

  const headers = {
    ...options.headers,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  const res = await fetch(url, {
    ...options,
    headers
  });

  if (res.status === 401) {
    console.warn("[AUTH] Token rejected. Logging out.");
    localStorage.clear();
    throw new Error("Unauthorized");
  }

  return res;
};
